export const DEVICE_COPY_SECTIONS = ['main', 'market', 'paymentProviders', 'config']

export const createEmptyFormData = () => ({
	main: {
		status: 'ACTIVE',
		fbox_version: 'v1',
		is_multi_user: false,
		update_available: false,
		disconnect_reason: '',
		terminal_id: null,
		device_terminal: {},
	},
	market: {},
	paymentProviders: {
		click: false,
		pay_me: false,
		apelsin: false,
		anor: false,
		uzqr: false,
	},
	config: {
		printer_type: 0,
		printer_name: 'fiscalbox_v1.0',
		case: 'v18/0/0',
		line_char_count: 42,
		space_after_print: 3,
		special_version: false,
		reader: false,
		local_labels_disabled: false,
		save_orders: false,
		check_time: false,
		local_mxik_disable: true,
		auto_cut_banner: false,
		new_api_enabled: false,
		over_cash_not_permitted: true,
		okm_validation: true,
		mark_version: false,
		qr_icon_center: false,
		save_order: null,
	},
})

const normalizeApiBoolean = (value, fallback = false) => {
	if (value === null || value === undefined) return fallback

	if (typeof value === 'string') {
		return value.toLowerCase() === 'true'
	}

	return Boolean(value)
}

export const parseCopySections = sections => {
	if (!sections) return DEVICE_COPY_SECTIONS

	const selectedSections = sections
		.split(',')
		.map(section => section.trim())
		.filter(section => DEVICE_COPY_SECTIONS.includes(section))

	return selectedSections.length > 0 ? selectedSections : DEVICE_COPY_SECTIONS
}

export const mapDeviceDetailToFormData = data => {
	const deviceConfig = data.device?.config ?? {}

	return {
		main: {
			device_serial_number: data.device_serial_number,
			user_id: data.user?.id ?? null,
			user_username: data.user?.username ?? null,
			address: data.device?.address ?? '',
			company_id: data.company?.id ?? null,
			company_name: data.company?.name ?? null,
			version_id: data.device?.version?.id ?? null,
			version_label: data.device?.version?.version_number ?? null,
			fiscal_token: data.device?.fiscal_token ?? null,
			status: data.device?.status ?? null,
			is_multi_user: data.device?.is_multi_user ?? false,
			update_available: data.device?.update_available ?? false,
			fbox_version: data.device?.fbox_version ?? null,
			disconnect_reason: data.device?.disconnect_reason ?? '',
			start_date: data.device?.start_date ?? null,
			end_date: data.device?.end_date ?? null,
			terminal_id: data.device?.terminal_id ?? null,
			device_terminal: data.device?.pos_terminal ?? {},
		},
		market: {
			market_id: data.device?.market?.id ?? null,
			market_name: data.device?.market?.name ?? '',
			region: data.device?.market?.region ?? '',
			district_id: data.device?.market?.district?.id ?? null,
			district_name: data.device?.market?.district?.name ?? '',
			lat: data.device?.market?.lat
				? parseFloat(data.device.market.lat)
				: null,
			long: data.device?.market?.long
				? parseFloat(data.device.market.long)
				: null,
		},
		paymentProviders: {
			pay_me: data.device?.pay_me ?? false,
			click: data.device?.click ?? false,
			apelsin: data.device?.apelsin ?? false,
			anor: data.device?.anor ?? false,
			uzqr: data.device?.uzqr ?? false,
			click_pass_service_id: data.device?.click_pass_service_id,
			click_pass_merchant_user_id: data.device?.click_pass_merchant_user_id,
			click_pass_secret_key: data.device?.click_pass_secret_key,
			click_qr_pay_service_id: data.device?.click_qr_pay_service_id,
			click_qr_pay_merchant_user_id: data.device?.click_qr_pay_merchant_user_id,
			click_qr_pay_secret_key: data.device?.click_qr_pay_secret_key,
			payme_subscribe_id: data.device?.payme_subscribe_id,
			payme_subscribe_token: data.device?.payme_subscribe_token,
			payme_merchant_id: data.device?.payme_merchant_id,
			payme_merchant_token: data.device?.payme_merchant_token,
			payme_merchant_test_token: data.device?.payme_merchant_test_token,
			payme_tip_id: data.device?.payme_tip_id,
			payme_tip_token: data.device?.payme_tip_token,
			apelsin_merchant_id: data.device?.apelsin_merchant_id,
			apelsin_merchant_user_id: data.device?.apelsin_merchant_user_id,
			apelsin_merchant_service_id: data.device?.apelsin_merchant_service_id,
			apelsin_merchant_secret_key: data.device?.apelsin_merchant_secret_key,
			anor_secret_key: data.device?.anor_secret_key,
			anor_branch_id: data.device?.anor_branch_id,
			uzqr_api_key: data.device?.uzqr_api_key,
			uzqr_endpoint: data.device?.uzqr_endpoint,
			uzqr_port: data.device?.uzqr_port,
		},
		config: {
			market_name: deviceConfig.market_name ?? '',
			lat: deviceConfig.lat ?? null,
			long: deviceConfig.long ?? null,
			cash_desc_number: deviceConfig.cash_desc_number ?? '',
			mac_address: deviceConfig.mac_address ?? '',
			printer_type: deviceConfig.printer_type ?? 0,
			printer_model: deviceConfig.printer_model ?? '',
			printer_name: deviceConfig.printer_name ?? 'fiscalbox_v1.0',
			printer_number: deviceConfig.printer_number ?? '',
			ip_address: deviceConfig.ip_address ?? '',
			dns: deviceConfig.dns ?? '',
			gateway: deviceConfig.gateway ?? '',
			case: deviceConfig.case ?? 'v18/0/0',
			line_char_count: deviceConfig.line_char_count ?? 42,
			additional_text: deviceConfig.additional_text ?? '',
			xumo_address: deviceConfig.xumo_address ?? '',
			factory_id: deviceConfig.factory_id ?? '',
			payment_connector_ip: deviceConfig.payment_connector_ip ?? '',
			space_after_print: deviceConfig.space_after_print ?? 3,
			mxik_timeout: deviceConfig.mxik_timeout ?? null,
			left_z_reports_validate: deviceConfig.left_z_reports_validate ?? null,
			special_version: normalizeApiBoolean(deviceConfig.special_version),
			reader: normalizeApiBoolean(deviceConfig.reader),
			local_labels_disabled: normalizeApiBoolean(
				deviceConfig.local_labels_disabled,
			),
			save_orders: normalizeApiBoolean(deviceConfig.save_orders),
			check_time: normalizeApiBoolean(deviceConfig.check_time),
			local_mxik_disable: normalizeApiBoolean(
				deviceConfig.local_mxik_disable,
				true,
			),
			auto_cut_banner: normalizeApiBoolean(deviceConfig.auto_cut_banner),
			new_api_enabled: normalizeApiBoolean(deviceConfig.new_api_enabled),
			over_cash_not_permitted: normalizeApiBoolean(
				deviceConfig.over_cash_not_permitted,
				true,
			),
			okm_validation: normalizeApiBoolean(deviceConfig.okm_validation, true),
			mark_version: normalizeApiBoolean(deviceConfig.mark_version),
			qr_icon_center: normalizeApiBoolean(deviceConfig.qr_icon_center),
			location_updated_date: deviceConfig.location_updated_date ?? null,
			ofd_registration_date: deviceConfig.ofd_registration_date ?? null,
			server_token: deviceConfig.server_token ?? '',
			save_order: normalizeApiBoolean(deviceConfig.save_order, null),
			eth_ip: deviceConfig.eth_ip ?? '',
			wi_fi_ip: deviceConfig.wi_fi_ip ?? '',
		},
	}
}

export const createCopyFormData = (sourceFormData, selectedSections) => {
	const nextFormData = createEmptyFormData()

	selectedSections.forEach(section => {
		nextFormData[section] = sourceFormData[section]
	})

	return {
		...nextFormData,
		main: {
			...nextFormData.main,
			device_serial_number: '',
		},
	}
}
